// Kart Oturumları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'cards.sessions';

export const cardSessionsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kart Oturumları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bir kartın müşteriye ya da personele verildiği andan teslim alındığı ana kadar geçen süreye "oturum" denir. Bu ekranda tüm kartların açık ve kapalı oturumlarını, oturumdaki yükleme, harcama ve iadeleri izlersiniz. Ekran yalnız görüntüleme içindir; oturum açma ve kapatma Kartlar ekranından yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Kart Oturumları'),
    stats: t(`${G}.regions.stats`, 'Oturum özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve Durum'),
    toolbar: t(`${G}.regions.toolbar`, 'Yenile'),
    table: t(`${G}.regions.table`, 'Oturum listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Özet kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Toplam Oturum, Açık Oturum ve Kapalı Oturum sayıları şirketinizdeki tüm oturumları gösterir. "İçeride Kalan Toplam", kapatılmış oturumlarda kartta harcanmadan ve iade edilmeden kalmış bakiyelerin toplamıdır.'),
      tips: [
        t(`${G}.s1.tip1`, 'İçeride kalan bakiye: oturumdaki Yükleme ve geri ödeme tutarlarından Satın Alma ve para çekme (İade) tutarları düşülerek bulunur; yalnız artıda kalan kapalı oturumlar toplanır.'),
        t(`${G}.s1.tip2`, 'Özet kartları arama ve durum filtresinden etkilenmez.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Oturumu bulun'),
      text: t(`${G}.s2.text`, '"Kart No, UID veya Cari Ara..." kutusuna kart numarası, kart UID veya kart sahibinin (cari ya da personel) adını yazın. "Durum" seçimiyle listeyi Tümü, Açık veya Kapalı oturumlara daraltın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Kartlar ekranında satırın ⋮ menüsündeki "Geçmiş Oturumlar" bu ekranı o kartın numarasıyla aranmış olarak açar.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Listeyi yenileyin'),
      text: t(`${G}.s3.text`, 'Sağdaki yenile düğmesi listeyi ve özet kartlarını yeniden yükler. Başka bir ekranda oturum açıldıysa veya kapatıldıysa güncel durumu görmek için kullanın.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Listeyi okuyun'),
      text: t(`${G}.s4.text`, 'Her satırda Kart No, Kart UID, Kart Sahibi, Oturum durumu (Açık / Kapalı), Başlangıç, Bitiş ve Kalan Bakiye görünür. En son açılan ya da kapatılan oturum en üsttedir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kalan Bakiye turuncu ise oturum kapatılmış ama kartta para kalmıştır; yeşil ise oturum açıktır.'),
        t(`${G}.s4.tip2`, 'Kart personele bağlıysa oturumun sahibi o personeldir; değilse oturum açılırken seçilen caridir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Oturum hareketlerini inceleyin'),
      text: t(`${G}.s5.text`, 'Satırın sonundaki ⋮ menüsünden "Ayrıntılar" Oturum Detayı penceresini açar. Burada oturumdaki her hareketin Tarihi, İşlem Tipi (Yükleme, Satın Alma, İade), Ödeme şekli (Nakit, POS, Kart), Cüzdan, Tutar ve işlem sonrası Kalan Bakiye görünür.'),
      tips: [
        t(`${G}.s5.tip1`, 'Satın Alma satırındaki fiş simgesi o alışverişte alınan ürünleri gösterir; başlıktaki "Tüm Satın Alınan Ürünler" oturumdaki bütün ürünleri listeler.'),
        t(`${G}.s5.tip2`, 'Açık oturumda kart kulüp girişinde kullanılıyorsa Konum alanında kartın İçeride / Dışarıda olduğu ve son giriş-çıkış saati görünür.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s6.title`, '6. Oturum açma ve kapatma'),
      text: t(`${G}.s6.text`, 'Bu ekranda oturum açılmaz veya kapatılmaz. Kartlar ekranında kartın ⋮ menüsünden "Oturumu Başlat" ile oturum açılır; "Oturumu Kapat" veya "Kartı Teslim Al" ile kapatılır. Bir kartta aynı anda yalnız bir açık oturum olabilir.'),
      tips: [
        t(`${G}.s6.tip1`, 'Sol üstteki geri oku sizi Kartlar ekranına döndürür.'),
      ],
    },
  ],
});
